module.exports = __webpack_public_path__ + "static/media/craigslist-purchase.c692b721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/craigslist-purchase.png
// module id = 1171
// module chunks = 27